<template>
  <div class="incomes-widget-container">
    <div v-if="loading" class="incomes-widget-loading">Loading...</div>
    <div v-else-if="error" class="incomes-widget-error">{{ error }}</div>
    <table v-else class="incomes-widget-table">
      <thead>
        <tr>
          <th>Income Account</th>
          <th class="incomes-widget-amount-header">Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="incomeAccounts.length === 0">
          <td colspan="2" class="incomes-widget-empty">No income accounts found</td>
        </tr>
        <tr v-else v-for="account in incomeAccounts" :key="account.id">
          <td>{{ account.accountName }}</td>
          <td class="incomes-widget-amount-cell">{{ formatCurrency(account.balance) }}</td>
        </tr>
      </tbody>
      <tfoot v-if="incomeAccounts.length > 0">
        <tr class="incomes-widget-total-row">
          <td class="incomes-widget-total-label">Total Income</td>
          <td class="incomes-widget-total-value">{{ formatCurrency(totalIncome) }}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import './styles/IncomesWidget.css';
import ApiService from '@/services/api.service';
import logger from '@/utils/logger';

export default {
  name: 'IncomesWidget',
  props: {
    companyId: { type: [String, Number], required: true }
  },
  data() {
    return {
      incomeAccounts: [],
      loading: true,
      error: null
    };
  },
  computed: {
    totalIncome() {
      return this.incomeAccounts.reduce((sum, acc) => sum + (acc.balance || 0), 0);
    }
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.error = null;
      try {
        const response = await ApiService.get(`/company-account/company/${this.companyId}`);
        const accountsData = Array.isArray(response.data) ? response.data : (response.data?.accounts || []);
        
        // Filter for income accounts only
        const incomeTypes = ['Income', 'Other Income'];
        this.incomeAccounts = accountsData
          .filter(acc => acc.active !== false && incomeTypes.includes(acc.accountType))
          .map(acc => ({
            id: acc.id,
            accountName: acc.accountName || acc.name,
            accountNumber: acc.accountNumber,
            balance: parseFloat(acc.currentBalance || acc.balance || 0)
          }))
          .filter(acc => acc.balance !== 0) // Only show accounts with non-zero balance
          .sort((a, b) => Math.abs(b.balance) - Math.abs(a.balance))
          .slice(0, 10); // Top 10
      } catch (error) {
        logger.error('Error fetching income accounts:', error);
        this.error = 'Failed to load data';
      } finally {
        this.loading = false;
      }
    },
    formatCurrency(amount) {
      if (amount === null || amount === undefined || isNaN(amount)) return '$0.00';
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount);
    }
  }
};
</script>

